import { render, staticRenderFns } from "./newBotPost.vue?vue&type=template&id=49056e3e&"
import script from "./newBotPost.vue?vue&type=script&lang=js&"
export * from "./newBotPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports